import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GetGuaranteedHours = gql`
  query GetGuaranteedHoursQuery($payPeriodId: Int!) {
    guaranteed_hours(pay_period_id: $payPeriodId) {
      edges {
        node {
          payPeriodId: pay_period_id
          payPeriodWeekId: pay_period_week_id
          firstname
          lastname
          hoursShortOfFourty: hours_short_of_fourty
          hoursActualGuaranteedPay: hours_actual_guaranteed_pay
          hoursSaved: hours_saved
        }
      }
    }   
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allGuaranteedHours = querySelector(data, '$.guaranteed_hours.edges[*].node', []);
  return {
    ...ownProps,
    data,
    allGuaranteedHours,
  };
};

const queryData = graphql(GetGuaranteedHours, {
  props: marshallData,
});

export const queryGetAllGuaranteedHoursGQL = compose(
  queryData,
  omitProps(['data']),
);
